import React, { useState } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';
import { Button, Spinner, Notification } from '@telus-uds/components-web';

import { getRequiredFields, buildUpdatePayload } from '../util';
import request from '../../../../../utils/request';

const FormActionButtons = ({
  userData,
  fieldData,
  formErrors,
  setFormErrors,
  formsControl,
  fetchUsers
}) => {
  const { id, email } = userData;

  const [loading, setLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState('');

  const isValid = () => {
    const requiredFields = getRequiredFields(
      fieldData.role,
      fieldData.channels
    );

    const errorObj = requiredFields.reduce((acc, currentField) => {
      if (
        currentField in fieldData &&
        (fieldData[currentField] === null ||
          fieldData[currentField].length === 0)
      ) {
        acc[currentField] = { message: 'Field is required' };
        return acc;
      }
      return acc;
    }, {});

    // Add XID format validation if XID is required
    if (requiredFields.includes('xid') && fieldData.xid) {
      if (!/^[0-9a-zA-Z]{7,8}$/.test(fieldData.xid)) {
        errorObj.xid = {
          message: 'Must be a minimum of 7 and maximum of 8 characters'
        };
      }
    }

    if (!_.isEmpty(errorObj)) {
      setFormErrors(errorObj);
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (isValid() && _.isEmpty(formErrors)) {
      setSubmitStatus('');
      setLoading(true);
      try {
        const updateResult = await request.post(
          `/users/${id}/update`,
          buildUpdatePayload(fieldData)
        );
        const formAccessResult = await request.put(
          '/disable-form-access-for-user-or-outlet',
          {
            email,
            forms: { ...formsControl }
          }
        );

        if (updateResult && formAccessResult) {
          setLoading(false);
          setSubmitStatus('success');
          fetchUsers();
        }
      } catch (err) {
        setLoading(false);
        setSubmitStatus('error');
        throw err;
      }
    }
  };

  return (
    <div>
      {['error', 'success'].includes(submitStatus) && (
        <Notification
          variant={submitStatus === 'error' ? { validation: 'error' } : { style: 'success' }}
          dismissible
        >
          {submitStatus === 'error'
            ? 'Error occurred while updating users profile'
            : 'User profile updated successfully!'}
        </Notification>
      )}
      <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
        <Spinner show={loading} variant={{ size: 'small' }} label="updating..." inline>
          <Button onPress={handleSubmit}>Update</Button>
        </Spinner>
      </div>
    </div>
  );
};

FormActionButtons.propTypes = {
  userData: PropTypes.shape({
    id: PropTypes.number,
    email: PropTypes.string
  }).isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired,
  formErrors: PropTypes.shape({}).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  formsControl: PropTypes.shape({
    disableBusinessApps: PropTypes.bool,
    disableBusinessConnect: PropTypes.bool,
    disableCallcenter: PropTypes.bool,
    disableIoT: PropTypes.bool
  }).isRequired,
  fetchUsers: PropTypes.func.isRequired
};

export default FormActionButtons;
